module.exports = __webpack_public_path__ + "static/death_dog-c9cc3c67ea03f6e7a3d48961304c3916.jpeg";